var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "add-extra-charges-pdf"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('fieldset', [_c('div', {
    attrs: {
      "id": "printPDFData"
    }
  }, [_c('div', {
    staticClass: "pagebreak"
  }, [_c('br'), _vm._v(" "), _c('b-form-fieldset', [_c('div', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Odd Size Shipments")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Odd Size Shipments Doc")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Mathadi/Varai/Union")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Mathadi/Varai/Union Doc")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Open Pick-up/Delivery")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Open Pick-up/Delivery Doc")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Appointment/CSD/Mall Delivery")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Appointment/CSD/Mall Delivery Doc")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Floor Pick-up/Delivery")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Floor Pick-up/Delivery Doc")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Oda")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Oda Doc")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Other Charges")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Other Charges Doc")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Allocation Type")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.awbChargesData), function(data, index) {
    return [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createddate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shipmentsized))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', [_vm._v(_vm._s(data.shipmentsizeddoc ? data.shipmentsizeddoc.Location : ""))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mathadi))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', [_vm._v(_vm._s(data.mathadidoc ? data.mathadidoc.Location : ""))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.portgages))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', [_vm._v(_vm._s(data.portgagesdoc ? data.portgagesdoc.Location : ""))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.specialdelivery))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', [_vm._v(_vm._s(data.specialdeliverydoc ? data.specialdeliverydoc.Location : ""))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.loadingunloading))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', [_vm._v(_vm._s(data.loadingunloadingdoc ? data.loadingunloadingdoc.Location : ""))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.oda))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', [_vm._v(_vm._s(data.odadoc ? data.odadoc.Location : ""))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.fulltruckload))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', [_vm._v(_vm._s(data.fulltruckloaddoc ? data.fulltruckloaddoc.Location : ""))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.allocationtype))])])]
  })], 2)])])])], 1)])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a30f10b","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/TripManagement/AddExtraCharges/AddExtraChargesPDF/AddExtraChargesPDF.html
// module id = 1412
// module chunks = 3